// extracted by mini-css-extract-plugin
export var fullWidthButton = "_i1-0";